import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import TopBar from '../../../components/TopBar';
import useDocumentTitle from '../../../hooks/useDocumentTitle';
import { Button, Stack } from '@mui/material';
import LinkIcon from '@mui/icons-material/Link';
import BusinessProfilesTable from '../components/BusinessProfilesTable';
import useBusinessProfileFilters from '../components/BusinessProfilesFilterHelper';
import { useTranslatedMessages } from '../../../hooks/useTranslatedMessages';
import SetupBusinessProfileModal from '../components/SetupBusinessProfileModal';

const filters = [
  {
    type: 'search',
    options: [
      {
        key: 'name',
        placeholder: 'Name',
      },
      {
        key: 'email',
        placeholder: 'Email',
      },
    ],
  },
];

function BusinessProfileListPage() {
  const [setupModalOpen, setSetupModalOpen] = useState(false);
  const user = useSelector((state) => state.user.user);
  const isOrganizationOwner = Array.isArray(user?.roles) && user.roles.includes('ORGANIZATION_OWNER');
  const { businessProfiles } = useTranslatedMessages();
  const page = businessProfiles?.pages?.list ?? {};
  const placeholders = page?.filters?.placeholders ?? {};
  const setupLabel = businessProfiles?.list_actions?.setup ?? 'Set up Business Profile';

  useDocumentTitle(page?.document_title ?? 'Business Profile List');
  const {
    selectedFilter,
    searchTerm,
    currentQuery,
    handleFilterChange,
    handleSearchChange,
    handleSearchKeyPress,
    handlePaginationChange,
  } = useBusinessProfileFilters({ defaultQuery: {} });

  const translatedFilters = [
    {
      type: 'search',
      options: [
        { key: 'name', placeholder: placeholders.name ?? 'Name' },
        { key: 'email', placeholder: placeholders.email ?? 'Email' },
      ],
    },
  ];

  return (
    <Stack direction="column" sx={{ mt: '-1rem' }}>
      <TopBar title={page?.top_bar_title ?? 'Business Profiles'}>
        {isOrganizationOwner && (
          <>
            <Button
              data-testid="setup-business-profile-button"
              variant="contained"
              color="primary"
              startIcon={<LinkIcon />}
              onClick={() => setSetupModalOpen(true)}
            >
              {setupLabel}
            </Button>
            <SetupBusinessProfileModal open={setupModalOpen} onClose={() => setSetupModalOpen(false)} />
          </>
        )}
      </TopBar>
      {/*<BusinessProfileListFilters*/}
      {/*  filters={translatedFilters}*/}
      {/*  selectedFilter={selectedFilter}*/}
      {/*  onFilterChange={handleFilterChange}*/}
      {/*  searchTerm={searchTerm}*/}
      {/*  onSearchChange={handleSearchChange}*/}
      {/*  onSearchKeyPress={handleSearchKeyPress}*/}
      {/*/>*/}
      <BusinessProfilesTable handlePaginationChange={handlePaginationChange} searchQuery={currentQuery} />
    </Stack>
  );
}

export default BusinessProfileListPage;
